import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { ToastProvider } from './components/Toast';
import { applyTheme, readStoredMode, resolveTheme } from './hooks/useTheme';
// Self-hosted Inter (bundled, works offline on exam tablets) — the app's professional UI font.
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import './styles.css';

// Apply the persisted theme before React mounts so there's no flash of the
// wrong colour scheme on page load.
applyTheme(resolveTheme(readStoredMode()));

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <ToastProvider>
        <App />
      </ToastProvider>
    </BrowserRouter>
  </React.StrictMode>
);
